import { LocationOn } from "@mui/icons-material";
import { Autocomplete, Box, CircularProgress, Grid, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
function LocationAutocompleteMulti({
  name,
  control,
  isLoading,
  options,
  setOptions,
  handleInputChange,
  handleValueSeleted,
  defaultValue,
  inputLabel,
  freeSolo,
  rules,
  helperText
}) {
  function normalizeSelectedValues(selectedValues) {
    const values = typeof selectedValues === "string"
      ? selectedValues.split("| ").map((value) => value.trim()).filter(Boolean)
      : selectedValues || [];

    return values.map((value) =>
      typeof value === "string" ? { placeId: value, mainText: value } : value
    );
  }

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
        <Autocomplete
          freeSolo={freeSolo}
          fullWidth
          filterOptions={(x) => x}
          options={options}
          multiple
          includeInputInList
          value={normalizeSelectedValues(value || defaultValue)}
          getOptionLabel={(option) => {
            if (typeof option === "string") return option;
            return option.mainText || "";
          }}
          isOptionEqualToValue={(option, value) => {
            // For string comparison
            if (typeof value === "string") {
              return option.mainText === value;
            }
            // For object comparison
            return option.placeId === value.placeId;
          }}
          autoComplete
          filterSelectedOptions
          loading={isLoading}
          noOptionsText="No locations"
          onBlur={onBlur}
          onChange={(event, newValues) => {
            setOptions((options) => (newValues.length > 0 ? [...newValues] : options));
            const simpleValues = newValues.map((val) =>
              typeof val === "string" ? val : val.mainText
            );
            onChange(simpleValues);
            // Handle any side effects with the full objects
            handleValueSeleted(newValues);
          }}
          onInputChange={handleInputChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={inputLabel}
              placeholder="Select a city from the list or press Enter to add a custom city."
              variant="outlined"
              inputRef={ref}
              error={!!error}
              helperText={error ? error.message : helperText || null}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            return (
              <li key={option.placeId} {...optionProps}>
                <Grid container alignItems="center">
                  <Grid item sx={{ display: "flex", width: 44 }}>
                    <LocationOn sx={{ color: "text.secondary" }} />
                  </Grid>
                  <Grid
                    item
                    sx={{
                      width: "calc(100% - 44px)",
                      wordWrap: "break-word"
                    }}
                  >
                    <Box component="span" sx={{ fontWeight: "bold" }}>
                      {option.mainText}
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {option.secondaryText}
                    </Typography>
                  </Grid>
                </Grid>
              </li>
            );
          }}
        />
      )}
    />
  );
}

export default LocationAutocompleteMulti;
